import {apiInstance} from '../api_Instance';
import {apiSecretInstance} from '../api_Instance';
export const authApi = {
  signUp: (data) => apiInstance.post(`/auth/signup/`, data),
  login: (data) => apiInstance.post(`/auth/login/`, data),
  token: (data) => apiInstance.post(`/auth/token/`, data),
  thread: (data) => apiInstance.post(`/threads/`, data),
  comment: (data, id) => apiInstance.post(`/threads/${id}/comments/`, data),
};
